import React from 'react';

type RoutingProps = {
  router: any;
  route: unknown;
};
const RoutingContext = React.createContext<RoutingProps>({
  router: null,
  route: null,
});

export const RoutingProvider = ({
  children,
  routing,
}: {
  children: React.ReactNode;
  routing: RoutingProps;
}) => {
  const { router, route } = routing;
  if (!router) {
    throw new Error('RoutingProvider requires a router prop');
  }
  if (!route) {
    throw new Error('RoutingProvider requires a route prop');
  }
  return (
    <RoutingContext.Provider value={{ router, route }}>
      {children}
    </RoutingContext.Provider>
  );
};

export const useRouting = () => {
  const context = React.useContext(RoutingContext);
  if (context === undefined) {
    throw new Error('useRouting must be used within a RoutingProvider');
  }
  return context;
};
